<template>
<div class="resetRegister m-login">
    <LoginHeader></LoginHeader>
    <div class="m-body">
        <div class="loginContent">
            <div class="outerBox">
                <div class="box">
                    <input type="text" class="username" v-model.trim="item.mobileno" auto-complete="off"
                           placeholder="请输入手机号" @blur="checkMobileno"
                           maxlength="11" :class="[rules.mobileno.status?'errorBorder':'']">
                    <i class="icon-phone icon"></i>
                </div>
                <div class="tip">
                    <transition name="fade">
                        <span v-if="rules.mobileno.status">{{rules.mobileno.msg}}</span>
                    </transition>
                </div>
            </div>
            <div class="outerBox">
                <div class="box">
                    <input type="text" class="psw" v-model.trim="usercode"  placeholder="请输入图形验证码" maxlength="4" :class="[rules.codeimg.status?'errorBorder':'']">
                    <img @click="createCodeImg" class="code_img" :src="imgCodeUrl" alt="">
                    <i class="icon-lock icon"></i>
                </div>
                <div class="tip">
                    <transition name="fade">
                        <span v-if="rules.codeimg.status">{{rules.codeimg.msg}}</span>
                    </transition>
                </div>
            </div>
            <div class="outerBox">
                <div class="box">
                    <input type="text" class="psw" v-model.trim="item.smscode" placeholder="请输入验证码"
                           @blur="checkSmscode"
                           maxlength="4" :class="[rules.smscode.status?'errorBorder':'']">
                    <van-button type="info" @click="_getSmsCode" :disabled="timer.countdown">
                        {{timer.countdown?timer.num+'s':'获取验证码'}}
                    </van-button>
                    <i class="icon-news icon"></i>
                </div>
                <div class="tip">
                    <transition name="fade">
                        <span v-if="rules.smscode.status">{{rules.smscode.msg}}</span>
                    </transition>
                </div>
            </div>
            <div class="outerBox">
                <div class="box">
                    <input type="password" class="username" v-model.trim="item.password" auto-complete="off"
                           placeholder="请输入密码" @blur="checkPassword"
                           minlength="6" maxlength="8" :class="[rules.password.status?'errorBorder':'']">
                    <i class="icon-lock icon"></i>
                </div>
                <div class="tip">
                    <transition name="fade">
                        <span v-if="rules.password.status">{{rules.password.msg}}</span>
                    </transition>
                </div>
            </div>
            <div class="outerBox">
                <div class="box">
                    <input type="password" class="username" v-model.trim="item.smspassword" auto-complete="off"
                           placeholder="请确认密码" @blur="checkSmspassword"
                           :class="[rules.smspassword.status?'errorBorder':'']">
                    <i class="icon-lock icon"></i>
                </div>
                <div class="tip">
                    <transition name="fade">
                        <span v-if="rules.smspassword.status">{{rules.smspassword.msg}}</span>
                    </transition>
                </div>
            </div>
            <slot name="tip"></slot>
        </div>
        <div class="loginBtn">
            <slot name="btn"></slot>
        </div>
    </div>
    <div class="m-footer">
        <router-link to="/m/login">返回登录</router-link>
        <slot name="resetRegister"></slot>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import LoginHeader from 'views/mobile/login/components/loginHeader'
import {getSmsCode, creatImgCode} from 'api/api'
export default {
    name: 'resetRegister',
    data() {
        return {
            timer: {
                countdown: false,
                num: 90
            },
            item: {
                mobileno: '',
                smscode: '',
                password: '',
                smspassword: ''
            },
            rules: {
                mobileno: {status: false, msg: '请输入正确的手机号'},
                smscode: {status: false, msg: '请输入验证码'},
                smspassword: {status: false, msg: '两次密码输入不一致'},
                password: {status: false, msg: '请输入6-8位密码'},
                codeimg: {status: false, msg: '请输入图形验证码'},
            },
            usercode: '',
            imgCodeUrl: '',
            codeEncryption: '',
        }
    },
    created() {
        this.createCodeImg()
    },
    methods: {
        // 获取图形验证码
        createCodeImg() {
            creatImgCode({
                data: {},
                success: data => {
                    // console.log(data.data)
                    this.usercode = ''
                    this.imgCodeUrl = data.result.base64
                    this.codeEncryption = data.result.codeEncryption
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 倒计时
        countdown() {
            let _this = this
            let timer = setInterval(() => {
                _this.timer.num--
            }, 1000)
            setTimeout(() => {
                clearInterval(timer)
                _this.timer.countdown = false
                _this.timer.num = 90
            }, 90000)
        },
        checkMobileno() {
            if (!/^1[3-9][0-9]{9}$/.test(this.item.mobileno)) {
                this.rules.mobileno.status = true
            } else {
                this.rules.mobileno.status = false
            }
        },
        checkcodeimg() {
            if (!this.usercode) {
                this.rules.codeimg.status = true
            } else {
                this.rules.codeimg.status = false
            }
        },
        checkSmscode() {
            if (!this.item.smscode || this.item.smscode.length !== 4) {
                this.rules.smscode.status = true
            } else {
                this.rules.smscode.status = false
            }
        },
        checkPassword() {
            if (!this.item.password) {
                this.rules.password.status = true
            } else {
                this.rules.password.status = false
            }
        },
        checkSmspassword() {
            if (!this.item.smspassword || this.item.smspassword !== this.item.password) {
                this.rules.smspassword.status = true
            } else {
                this.rules.smspassword.status = false
            }
        },
        _getSmsCode() {
            this.checkMobileno()
            this.checkcodeimg()
            if (!this.rules.mobileno.status && !this.rules.codeimg.status) {
                this.timer.countdown = true
                this.setLoading(true)
                getSmsCode({
                    data: {
                        mobileno: this.item.mobileno,
                        usercode: this.usercode,
                        codeEncryption: this.codeEncryption
                    },
                    success: () => {
                        this.$toast.success('获取验证码成功！')
                        this.countdown()
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.timer.countdown = false
                        this.$toast.fail(data.msg)
                    }
                })
            }
        },
        ver() {
            this.checkMobileno()
            this.checkSmscode()
            this.checkPassword()
            this.checkSmspassword()
            if (!this.rules.mobileno.status && !this.rules.smscode.status && !this.rules.password.status && !this.rules.smspassword.status) {
                this.$emit('resetregister', this.item)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {
        LoginHeader
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~views/mobile/login/login";

.resetRegister {
}
</style>